import { useMutation } from '@tanstack/react-query';
import { submitManagerFeedback } from '../../../../shared/service/widgetApi';
import { MutationCallbacks } from '../../../../shared/types/mutation';
import { ManagerFeedbackPayload } from '../types';

export default function useSubmitManagerFeedback({
  onSuccess,
  onError,
}: MutationCallbacks) {
  const { mutate, isPending } = useMutation({
    mutationFn: (data: ManagerFeedbackPayload) => submitManagerFeedback(data),
    onSuccess,
    onError,
  });

  return { submitFeedback: mutate, isSubmitting: isPending };
}
